import { render, staticRenderFns } from "./Sign.vue?vue&type=template&id=a177aa8c&scoped=true&"
import script from "./Sign.vue?vue&type=script&lang=tsx&"
export * from "./Sign.vue?vue&type=script&lang=tsx&"
import style0 from "./Sign.vue?vue&type=style&index=0&id=a177aa8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a177aa8c",
  null
  
)

export default component.exports